import React, { useState, useEffect, useContext } from 'react';
import LayoutSelectButton from 'components/layout/LayoutSelectButton.jsx';
import LayoutCarousel from 'components/layout/LayoutCarousel.jsx';
import LayoutMostEfficient from 'components/layout/LayoutMostEfficient.jsx';
import LayoutNavSubSection from 'components/layout/LayoutNavSubSection.jsx';
import PerSectionDownloadButtons from 'components/layout/PerSectionDownloadButtons.jsx';
import LayoutNestCombinations from 'components/layout/LayoutNestCombinations.jsx';

// A nest's tab leaves out the words all of the section's part names start with ("Hard cardboard of the"), which its
// heading already says: tabs shrink to fit a row (shortcode_tab_item_title_of_9 is 120px), and nine of whole part
// names do not fit one. Every part keeps a word. Only until Claude's labels are stored (navSection.tab_labels,
// LayoutPartNestingTabLabels).
export const nestTabLabel = (partNames, sectionPartNames) => {
  const words = sectionPartNames.map((name) => name.trim().split(/\s+/));
  let common = 0;
  while (words.every((nameWords) => nameWords.length > common + 1 && nameWords[common] === words[0][common])) { common += 1; }
  const label = partNames.map((name) => name.trim().split(/\s+/).slice(common).join(' ')).join(' & ');
  return label.charAt(0).toUpperCase() + label.slice(1);
};

const LayoutNavSection = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const [items, setItems] = useState([]);
  const [activeMember, setActiveMember] = useState(props.navSection.first_member);
  const [error, setError] = useState("error");
  // A section of parts no template holds (LayoutNavSectionsDynamicNestingDecorator) opens on their nest of every part,
  // then gets a tab for each nest of the combinations ranked for it: the best combination's nests first, selected and
  // flagged, every tab on the sheet the ranking was made on. The others are picked as templates are.
  const [subSections, setSubSections] = useState(props.navSection.sub_sections);
  const [ranked, setRanked] = useState(false);

  const sectionBusy = () => subSections.some((sub_section) => sub_section.members.some((member) => props.activeRedraws.includes(member.uuid)));

  const showRankedNests = (combinations, layout) => {
    const nests = [];
    combinations.forEach((combination) => combination.members.forEach((member) => {
      if (!nests.some((nest) => nest.uuid === member.uuid)) { nests.push(member); }
    }));
    if (nests.length < 2) { return; }

    const bestUuids = combinations[0].members.map((member) => member.uuid);

    setItems([]);
    setActiveTab(0);
    setRanked(true);
    setSubSections(nests.map((member) => ({
      label: (props.navSection.tab_labels || {})[member.uuid] || nestTabLabel(member.part_names, props.navSection.part_names),
      parts: member.parts,
      part_names: member.part_names,
      members: [{ ...member, initial_layout: layout }],
      most_efficient_member_uuids: bestUuids.includes(member.uuid) ? [{ uuid: member.uuid }] : [],
      select_on_mount: bestUuids.includes(member.uuid),
    })));
  }

  const selectedItemCount = (sub_section) => {
    let item_uuids = items.map((i) => i.uuid );
    let sub_section_uuids = sub_section.members.map((m) => m.uuid);
    let intersection = item_uuids.filter(value => sub_section_uuids.includes(value));
    return intersection.length;
  }

  const requiredPartsMissingError = () => {
    let item_parts = items.map((item) => item.part_names).flat();
    let missingParts = props.navSection.part_names.filter(value => !item_parts.includes(value));

    if (missingParts.length > 0) {
      return `${window.wording_select_templates_for_parts.replace('(?)',missingParts.map(str => `"${str}"`).join(', ')) }`;
    }

    return '';
  }

  const isMostEfficient = (member_uuid) => {
    for(let key in mostEfficients) {
      for(let i=0; i< mostEfficients[key].length; i++) {
        let member = mostEfficients[key][i];
        if(member.uuid == member_uuid) {
          return true;
        }
      }
    }
    return false;
  }

  useEffect(() => {
    let item_part_names = items.map((item) => item.part_names).flat();
    props.setSelectedMembers(items, `index_${props.index}`);
  }, [items])

  useEffect(() => {
    props.setRequiredParts(props.navSection.part_names);
  }, [])

  const onItemsChanged = () => {
    if(items.length == 0) { return };
    let lastItem = items[items.length - 1];
    for(let i = 0; i< items.length -1; i++){
      let intersection = items[i].parts.filter(x => lastItem.parts.includes(x));
      if( intersection.length > 0 ){
        setItems((prev) => prev.filter((item) => item.uuid != items[i].uuid))
      }
    }
  }

  useEffect(onItemsChanged, [items]);

  const getTab = (sub_section, index) => {
    let totalTabCount = subSections.length;

    return (<div
      key={`tab_${props.index}_${index}`}
      onClick={() => setActiveTab(index)}
      className={`shortcode_tab_item_title shortcode_tab_item_title_of_${totalTabCount} ${props.activeRedraws.length > 0 && 'disabledForm'} ${index != activeTab && 'active'} ${index == activeTab && 'inactivetab'}`}>
       {sub_section.label}

        {selectedItemCount(sub_section) > 0 && (
          <span className="badge bgred"> {selectedItemCount(sub_section)}
        </span>)
      }
    </div>)
  }

  const getSubSection = (sub_section, index) => {
    return <LayoutNavSubSection
      key={`sub_section_${props.index}_${index}_${ranked}`}
      sub_section={sub_section}
      index={index}
      selectOnMount={Boolean(sub_section.select_on_mount)}
      activeTab={activeTab}
      activeRedraws={props.activeRedraws}
      setActiveRedraws={props.setActiveRedraws}
      items={items}
      setItems={setItems}
      requiredPartsMissingError={requiredPartsMissingError}
    />
  }

  return (
    <div className={`col-lg-12 navSection ${props.navSection.type == 'two_layers' ? 'card navSectionCardModif' : ''}`}>
      {props.navSection.type == 'two_layers' && (
      <div className="promo-block">
        <div className="promo-text"> {props.navSection.label} </div>
        <div className="center-line"></div>
      </div>
      )}

      {props.navSection.combinations_url && (
        <LayoutNestCombinations
          combinationsUrl={props.navSection.combinations_url}
          member={props.navSection.sub_sections[0].members[0]}
          busy={sectionBusy()}
          onRanked={showRankedNests}
        />
      )}

      {(props.navSection.type == 'two_layers' || props.navSection.type == 'one_layer') && subSections.length > 1 && (
       <div className="shortcode_tabs shortcode_tabs_layout">
        {subSections.map(getTab)}
      </div>)}

      <div className={`col-lg-12 newtabcontent navSectionContent ${props.navSection.type == 'two_layers' ? '' : 'navSectionContentWider'} `}>
        {subSections.map(getSubSection)}
      </div>

      {props.comboGuestPresent && (
        <div className="col-lg-12 navSectionDownloads">
          <PerSectionDownloadButtons
            items={items}
            activeRedraws={props.activeRedraws}
          />
        </div>
      )}
   </div>
  )
}

export default LayoutNavSection;
